var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { DocumentService } from './../services/document.service';
import { OrderLineItemTypeEnum } from './../../shared/enums/order-lineitem-type.enum';
import { EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Modal } from 'ngx-modal';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MessageService } from '../../shared/services/message.service';
import { CommonMessage } from '../common/common-messages';
import { Constants, IsoCodeThree, MemberType } from '../common/constants';
import { DeliveryPreference, MemberLevel, OrderType, PurchaseFlow, cancelOrderOptions, BonusStatus } from '../common/enumerations';
import { AccountTypeConstants } from '../constants/account-type.constants';
import { PaymentMethodTypeConstants } from '../constants/payment-method-types.constants';
import { AccountType } from '../enums/echeck-accounttypes.enum';
import { MemberStatus } from '../enums/member-status.enum';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { MessageTypeEnum } from '../enums/message-type.enums';
import { NotificationType } from '../enums/notification-types.enum';
import { SecType } from '../enums/payment-ach-sectypes.enum';
import { AddressType, OrderStatus as OrderStatusEnums, PaymentMethodTypes, PaymentStatusId, ShippingType } from '../enums/order-source-type';
import { PaymentCardTypes } from '../enums/payment-card-types.enum';
import { Status } from '../enums/ticket-status.enum';
import { Priority, SourceType, SubtypesEnums, TicketType, Types } from '../enums/ticket-type.enum';
import { AddressInformation } from '../interface/address-detail-info';
import { BillingInformation } from '../interface/billing-info';
import { ShippingInformation } from '../interface/shipping-info';
import { TaxType } from '../interface/tax-type.interface';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { CreateTicketRequest } from '../interface/ticketingsystem/ticket-create';
import { DeleteModal } from '../models/delete-modal';
import { OrderInfoTab } from '../models/order-info-tab-model';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { AppConfigService } from '../services/app-config.service';
import { CustomerService } from '../services/customer.service';
import { DepartmentService } from '../services/department.service';
import { OrderService } from '../services/order.service';
import { ShippingAddressInfoConfigService } from '../services/shipping-config.service';
import { OrderSourceTypes } from '../enums/order-source.enum';
import { CheckoutConfigService } from '../services/checkout-config.service';
import { StoreMetaDataConstants } from '../constants/store-metadata.constants';
import { catchError, concatMap, debounceTime, map, takeUntil } from 'rxjs/operators';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { Months } from '../enums/months.enum';
import { Subject } from 'rxjs';
import { BonusConstants } from '../constants/bonus-status.constants';
import { switchMap } from 'rxjs/operators';
import { OrderStatuses } from '../../common/enums/orderStatus.enum';
import { PersonalInfoConfigService } from '../services/personal-info-config.service';
// import { GovernmentIdentificationType } from '../enums/government-identification-type.enum';
var RecentOrderViewComponent = /** @class */ (function () {
    function RecentOrderViewComponent(_customerservice, departmentService, messageService, _commonService, _orderservice, _translatePipe, _formbuilder, _cacheService, _appConfigService, _shippingAddressInfoConfigService, documentRef, _documentService, _checkoutConfigService, personalInfoConfigService) {
        var _this = this;
        this._customerservice = _customerservice;
        this.departmentService = departmentService;
        this.messageService = messageService;
        this._commonService = _commonService;
        this._orderservice = _orderservice;
        this._translatePipe = _translatePipe;
        this._formbuilder = _formbuilder;
        this._cacheService = _cacheService;
        this._appConfigService = _appConfigService;
        this._shippingAddressInfoConfigService = _shippingAddressInfoConfigService;
        this.documentRef = documentRef;
        this._documentService = _documentService;
        this._checkoutConfigService = _checkoutConfigService;
        this.personalInfoConfigService = personalInfoConfigService;
        this.isDesc = false;
        this.sortColumn = "orderDate";
        this.paymentInfo = false;
        this.tickets = [];
        this.ticketsIsDesc = false;
        this.ticketsSort = "ASC";
        this.ticketsSortColumn = "ID";
        this.ticketsPageNumber = 1;
        this.ticketsPageSize = 10;
        this.ticketsPageCount = 0;
        this.orderStatuses = [];
        this.states = [];
        this.countries = [];
        this.orderNotes = [];
        this.orderLogs = [];
        this.displayUserName = false;
        this.paymentType = PaymentMethodTypes;
        this.showprint = false;
        this.participatingCountries = [];
        this.paymentStatusEnum = PaymentStatusId;
        this.showCancelIcon = true;
        this.FBOManageTicketPermissions = [
            Permission.MANAGE_TICKETS_CREATE,
            Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
            Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
            Permission.MANAGE_TICKETS_VIEW
        ];
        this.FBOManageOrderPermissions = [
            Permission.REGULAR_ORDER_MANAGE,
            Permission.REGULAR_ORDER_CANCEL,
            Permission.POS_ORDER_MANAGE,
            Permission.POS_ORDER_CANCEL
        ];
        this.ServiceOrderPermissions = [
            Permission.REPLACEMENT_ORDER_CREATE,
            Permission.REPLACEMENT_ORDER_MANAGE,
            Permission.REPLACEMENT_ORDER_CANCEL
        ];
        this.RefundPermissions = [
            Permission.REGULAR_ORDER_REFUND,
            Permission.POS_ORDER_REFUND
        ];
        this.commissionActivtiesPermissions = [
            Permission.COMMISSION_ACTIVITIES
        ];
        this.orderStatusId = OrderStatusEnums;
        this.operatingCountry = 57;
        this.AccountTypeConstants = AccountTypeConstants;
        this.accountTypeEnums = AccountType;
        this.deliveryPreference = DeliveryPreference;
        this.retailSubTotal = 0.0;
        this.memberTypeEnums = MemberTypeEnum;
        this.paymentMethodTypeConstants = PaymentMethodTypeConstants;
        this.orderTicketsId = "orderTicketsId";
        this.maxlimit = environment.maxlimit;
        this.accountCreateNotification = false;
        this.purchaseFlowEnum = PurchaseFlow;
        this.printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
        this.taxType = TaxType;
        this.enableServiceOrder = environment.enableServiceOrder;
        this.OrderLineItemTypeEnum = OrderLineItemTypeEnum;
        this.trackingUrls = [];
        this.orderSources = OrderSourceTypes;
        this.showPrintOption = false;
        this.hasRegularOrderRefundPermission = false;
        this.hasPOSOrderRefundPermission = false;
        this.isCancelCheckBoxDisabled = false;
        this.isCancelAndRefundCheckBoxDisabled = false;
        this.orderStatusChangeReasons = [];
        this.refundAmount = 0.0;
        this.paymentAmount = 0.0;
        this.enablePrintInvoiceIcon = false;
        this.isMemberSearchSucess = false;
        this.FPCOrFBONotFoundErrorMessage = false;
        this.errorMessage = false;
        this.isNotAuthorizedCountry = false;
        this.isConfirmationModalMessage = false;
        this.isDistributorIdChangedSuccessMessage = false;
        this.closeTabForParticularDistributor = new EventEmitter();
        this.bonusStatuses = [];
        this.submitProcessOrder = false;
        this.bonusDetails = {};
        this.ngUnsubscribe = new Subject();
        this.orderLevelDiscount = 0.0;
        this.orderTypeIdForRetail = Constants.RETAIL_ORDER_TYPE_ID;
        this.systemOrderNumberAcknowledgedFromAs400 = false;
        this.AcknowledgeType = 57; // System Order Number Received From AS400
        this.createOrderNote = function (webOrderId, note, isDisplayNotification, orderStatusChangeReasonId, note1) {
            _this._orderservice
                .createOrderNote(webOrderId, note, _this.userInfo.userId, orderStatusChangeReasonId)
                .pipe(concatMap(function (response) {
                return response && response.success && note1
                    ? _this._orderservice
                        .createOrderNote(webOrderId, note1, _this.userInfo.userId, orderStatusChangeReasonId)
                        .pipe(catchError(function (err) { return of([response, []]); }), map(function (response1) { return [response, response1]; }))
                    : of([response, []]);
            }))
                .subscribe(function (data) {
                if (isDisplayNotification) {
                    _this.showNotification(data[0]);
                }
            }, function (error) {
                _this.showNotification(null);
            });
        };
        this.closeRestrictionPopup = function () {
            _this.memberRestrictions.close();
        };
    }
    RecentOrderViewComponent.prototype.ngOnInit = function () {
        // this.memberGovernmentIdentifiations=[];
        if (!this.orderInfo.emailID) {
            this.getStoreInfo(this.orderInfo.homeCountry);
            this.isTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"), AccessLevel.Customer_Service);
            this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[3] + "]"), AccessLevel.Customer_Service);
            this.hasCommissionActvityPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.commissionActivtiesPermissions + "]"), AccessLevel.Customer_Service);
            var billingAddress = this.personalInfoConfigService.getSettings(this.orderInfo.homeCountry);
            this.billingAddressMode = billingAddress && billingAddress.billingAddressMode ? billingAddress.billingAddressMode : false;
            this.subscribeDisputeTickets();
            this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
            this.deleteModal.viewActionButtons = false;
            this.getCountries();
            this.getStates();
            this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        }
        else {
            this.accountCreateNotification = true;
        }
        if (this.appConfig.removeCancelAndRefund) {
            this.showCancelAndRefundRadio = false;
        }
        else {
            this.showCancelAndRefundRadio = true;
        }
    };
    RecentOrderViewComponent.prototype.getTicketTypesAndSubTypes = function () {
        var _this = this;
        this.departmentService.getTicketTypesAndSubTypes(this.operatingCountry).subscribe(function (response) {
            if (response) {
                var ticketType = response.find(function (type) { return type.value === TicketType.Order; });
                if (ticketType) {
                    _this.ticketTypeId = ticketType.id;
                }
            }
        });
    };
    /**
     * Gets fbo / retail oder information
     */
    RecentOrderViewComponent.prototype.getRecentOrderInformation = function () {
        var _this = this;
        this._orderservice.getRecentOrderInformation(this.orderInfo.webOrderID).subscribe(function (response) {
            if (response) {
                _this.orderInformation = response;
                if (_this.orderInformation && _this.orderInformation.orderStatusId) {
                    if (_this.orderInformation.orderStatusId === _this.orderStatusId.Completed) {
                        _this.enablePrintInvoiceIcon = true;
                    }
                    _this.phoneNumberFormat = _this._commonService.getPhoneNumberFormatByCountryCode(_this.orderInformation.countryCode);
                }
                if (_this.orderInformation && _this.orderInformation.orderStatusId) {
                    if (_this.orderInformation.orderStatusId === OrderStatuses.Refunded) {
                        var total_1 = 0;
                        _this._orderservice.getRefundAmount(_this.orderInfo.webOrderID).subscribe(function (res) {
                            if (res && res.length > 0) {
                                _this.refundAmountInfo = res;
                                _this.refundAmountInfo.forEach(function (item) {
                                    if (item.refundAmount != null) {
                                        total_1 += item.refundAmount;
                                    }
                                });
                                _this.refundAmount = total_1;
                            }
                        });
                    }
                }
                if (_this.orderInformation.orderPayments) {
                    _this.orderInformation.orderPayments.forEach(function (x) {
                        if (x.paymentAmount != null) {
                            _this.paymentAmount += x.paymentAmount;
                        }
                    });
                }
                _this.orderTypeId = _this.orderInformation.orderTypeId;
                _this.trackingModel = response.trackingModel;
                if (_this.trackingModel) {
                    for (var _i = 0, _a = Object.entries(_this.trackingModel); _i < _a.length; _i++) {
                        var _b = _a[_i], key = _b[0], value = _b[1];
                        if (value) {
                            _this.trackingUrls.push(value);
                        }
                    }
                }
                if (_this.orderInformation && _this.orderInformation.taxMetaData
                    && _this.orderInformation.taxMetaData.orderTaxCharges
                    && _this.orderInformation.taxMetaData.orderTaxCharges.length > 0) {
                    var gst = _this.orderInformation.taxMetaData
                        .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.GST_TAX; });
                    var pst = _this.orderInformation.taxMetaData
                        .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.PST_TAX; });
                    _this.gstTax = gst ? gst.taxAmount : 0;
                    _this.pstTax = pst ? pst.taxAmount : 0;
                }
                if (response.isDM) {
                    _this.orderInformation.totalDiscountAmount = response.totalDiscountAmount && response.totalDiscountAmount > 0 ? response.totalDiscountAmount : null;
                }
                // PS2020-489 --> USA Tax issue
                if (_this.orderInformation && (!_this.orderInformation.orderTax || _this.orderInformation.orderTax <= 0)
                    && _this.orderInformation.countryCode === IsoCodeThree.USA && _this.orderInformation.taxMetaData
                    && _this.orderInformation.taxMetaData.orderTaxCharges
                    && _this.orderInformation.taxMetaData.orderTaxCharges.length > 0) {
                    var slsTax = _this.orderInformation.taxMetaData
                        .orderTaxCharges.find(function (tax) { return tax.taxChargeType === TaxType.SLS_TAX; });
                    _this.orderInformation.orderTax = slsTax ? slsTax.taxAmount : 0;
                }
                _this.orderLevelDiscount = _this.orderInformation.orderLevelDiscount;
                _this.retailDeliveryFee = _this.orderInformation.retailDeliveryFee ? _this.orderInformation.retailDeliveryFee : 0;
                _this.retailSubTotal = 0.0;
                _this.orderInformation.orderLineItems.forEach(function (item) { _this.retailSubTotal = (_this.retailSubTotal + item.totalRetailPrice); });
                if (_this.orderInformation && _this.orderInformation.userName && (_this.orderInformation.source === Constants.CUSTOMER_SERIVCE || _this.orderInformation.source === Constants.POS_ORDER || _this.orderInformation.source === Constants.SERVICE_ORDER)) {
                    _this.displayUserName = true;
                }
                if (_this.orderInformation && _this.orderInformation.distrubutorId &&
                    (_this.orderStatusId.Failed === _this.orderInformation.orderStatusId)) {
                    _this.enableCloneOrderFeature = _this._commonService.isenableCloneOrderCountries(_this.orderInformation.countryCode);
                }
                else {
                    if (_this.orderStatusId.Failed === _this.orderInformation.orderStatusId) {
                        var warningMessage = _this._translatePipe.get('common.Enrollment Failed,so we cannot allow to clone the order');
                        _this._commonService.createNotification('', warningMessage.value, NotificationType.ERROR);
                    }
                }
                _this.getMemberInformation();
                if (_this.orderInformation.orderStatusId === OrderStatusEnums.In_Complete) {
                    _this.orderInformation.orderStatusId = OrderStatusEnums.Accepted;
                }
                var orderStatus = _this.orderStatuses.find(function (status) { return status.id === _this.orderInformation.orderStatusId; });
                _this.orderInformation.orderStatus = orderStatus ? orderStatus.description : '';
                _this.checkoutConfig = _this._checkoutConfigService.getSettings(_this.orderInfo.homeCountry, _this.memberInfo);
                if (_this.orderInformation.orderGroupId !== OrderType.REPLACEMENT && _this.orderInformation.orderGroupId !== OrderType.POS) {
                    _this.hasManageServiceOrderPermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + _this.ServiceOrderPermissions + "]"), AccessLevel.Customer_Service);
                }
                if (_this.orderInformation.orderGroupId === OrderType.REGULAR) {
                    _this.hasManageOrderPermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + _this.FBOManageOrderPermissions[0] + "]"), AccessLevel.Customer_Service);
                    _this.hasCancelOrderPermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + _this.FBOManageOrderPermissions[1] + "]"), AccessLevel.Customer_Service);
                    _this.hasCancelPOSOrderPermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + _this.FBOManageOrderPermissions[3] + "]"), AccessLevel.Customer_Service);
                    _this.hasPOSOrderRefundPermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + _this.RefundPermissions[1] + "]"), AccessLevel.Customer_Service);
                    _this.hasRegularOrderRefundPermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + _this.RefundPermissions[0] + "]"), AccessLevel.Customer_Service);
                    if (_this.storeInfo && _this.storeMetadata && _this.storeMetadata.length > 0) {
                        var hasOrderUpdatePermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.ORDER_STATUS_UPDATE + "]"), AccessLevel.Store, _this.storeInfo ? _this.storeInfo.id : null);
                        var orderStatusUpdateAttribute = _this.storeMetadata.find(function (x) { return (x.attribute &&
                            x.attribute.toLowerCase() === StoreMetaDataConstants.ENABLE_ORDER_STATUS_UPDATE.toLowerCase()); });
                        var storeOrderUpdateFeatureEnabled = orderStatusUpdateAttribute && orderStatusUpdateAttribute.metaDataValue && orderStatusUpdateAttribute.metaDataValue === 'true' ? true : false;
                        _this.hasManageOrderUpdatePermission = hasOrderUpdatePermission && storeOrderUpdateFeatureEnabled;
                    }
                }
                if (_this.orderInformation.orderGroupId === OrderType.REPLACEMENT) {
                    _this.hasCancelServiceOrderPermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + _this.ServiceOrderPermissions[2] + "]"), AccessLevel.Customer_Service);
                    _this.hasManageServiceOrderUpdatePermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + _this.ServiceOrderPermissions[1] + "]"), AccessLevel.Customer_Service);
                    if (_this.storeInfo && _this.storeMetadata && _this.storeMetadata.length > 0) {
                        var hasServiceOrderUpdatePermission = _this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + Permission.REPLACEMENT_ORDER_STATUS_UPDATE + "]"), AccessLevel.Customer_Service);
                        var orderStatusUpdateAttribute = _this.storeMetadata.find(function (x) { return (x.attribute &&
                            x.attribute.toLowerCase() === StoreMetaDataConstants.ENABLE_SERVICE_ORDER.toLowerCase()); });
                        var storeOrderUpdateFeatureEnabled = orderStatusUpdateAttribute && orderStatusUpdateAttribute.metaDataValue && orderStatusUpdateAttribute.metaDataValue === 'true' ? true : false;
                        var isPickupOrder = _this.orderInformation.orderShippings[0].deliveryPreferenceId === ShippingType.PICKUP ? true : false;
                        _this.hasManageOrderUpdatePermission = (hasServiceOrderUpdatePermission && isPickupOrder) && storeOrderUpdateFeatureEnabled;
                    }
                }
                //verifying wether respective fields are undefined or not.. if undefined assigning respective model
                if (!_this.orderInformation.billingInfo) {
                    _this.orderInformation.billingInfo = new BillingInformation();
                    _this.orderInformation.billingInfo.address = new AddressInformation();
                }
                if (!_this.orderInformation.shippingInfo) {
                    _this.orderInformation.shippingInfo = new ShippingInformation();
                    _this.orderInformation.shippingInfo.address = new AddressInformation();
                }
                else if (response.shippingInfo.shippingDate) {
                    _this.orderInformation.shippingInfo.shippingDate = new Date(response.shippingInfo.shippingDate);
                }
                if (_this.orderInformation.orderShippings.length > 0 && _this.orderInformation.orderShippings[0].billingAddressId) {
                    var addressId = _this.orderInformation.orderShippings[0].billingAddressId;
                    // this.getAddressInfo(addressId, true);
                }
                else if (_this.orderInformation.orderShippings.length > 0 && _this.orderInformation.orderShippings[0].shippingAddressId) {
                    var addressId = _this.orderInformation.orderShippings[0].shippingAddressId;
                    // this.getAddressInfo(addressId, true);
                }
                if (_this.orderInformation.orderShippings.length > 0 && !_this.orderInformation.shippingInfo.warehouse) {
                    _this.orderInformation.shippingInfo.warehouse = _this.orderInformation.orderShippings[0].distributionCenter;
                }
                if (_this.orderInformation && _this.orderInformation.storePostedOffset === 0) {
                    if (_this.orderInformation && _this.orderInformation.createdDate !== null) {
                        _this.orderInformation.createdDate = moment.utc(_this.orderInformation.createdDate).format('DD-MMM-YYYY HH:mm:ss');
                    }
                    if (_this.orderInformation && _this.orderInformation.orderPostedDate !== null) {
                        _this.orderInformation.orderPostedDate = moment.utc(_this.orderInformation.orderPostedDate).format('DD-MMM-YYYY HH:mm:ss');
                    }
                }
                else {
                    if (_this.orderInformation && _this.orderInformation.createdDate !== null && _this.orderInformation.storePostedOffset) {
                        _this.orderInformation.createdDate = moment.utc(_this.orderInformation && _this.orderInformation.createdDate)
                            .utcOffset(_this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                    }
                }
                if (_this.orderInformation && _this.orderInformation.orderPostedDate !== null && _this.orderInformation.storePostedOffset) {
                    _this.orderInformation.orderPostedDate = moment.utc(_this.orderInformation && _this.orderInformation.orderPostedDate)
                        .utcOffset(_this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                }
                // calculating shipping cost and shippingTax based on calculateShippingWithTax flag.
                _this.getShippingCostWithShippingTax();
                if (_this.orderInformation.orderShippings.length > 0) {
                    _this.shippingAddressInfo = null;
                    _this.memberAddressDetails = [];
                    _this.orderInformation.addresses.forEach(function (address) {
                        _this.memberAddressDetails.push({
                            id: address.id,
                            shippingAddress: {
                                shipToName: address.name,
                                addressLine1: address.addressLine1,
                                addressLine2: address.addressLine2,
                                addressLine3: address.addressLine3,
                                addressLine4: address.addressLine4,
                                addressType: address.addressType,
                                firstName: address.firstName,
                                lastName: address.lastName,
                                middleName: address.middleName,
                                city: address.city,
                                stateId: address.stateId,
                                countryId: address.countryId,
                                postalCode: address.postalCode,
                                addressVerified: address.addressVerified,
                                shippingPhone: address.phone,
                                email: address.email,
                                phoneType: address.phoneType,
                                deliveryInstruction: address.deliveryInstruction,
                                phone: address.phone
                            }
                        });
                    });
                    _this.showDeliveryInstructions = (_this.appConfig && _this.appConfig.enableDeliveryInstructions) ? _this.appConfig.enableDeliveryInstructions : false;
                    if (_this.memberAddressDetails.length > 0) {
                        var shippingAddressDetails = _this.memberAddressDetails.find(function (address) {
                            return (address.shippingAddress.addressType === AddressType.SHIPPING) || (address.shippingAddress.addressType === AddressType.PICKUP_PERSON) || (address.shippingAddress.addressType === AddressType.PICKUP) || (address.shippingAddress.addressType === AddressType.DROPSHIP);
                        });
                        if (shippingAddressDetails) {
                            _this.shippingAddressInfo = shippingAddressDetails.shippingAddress;
                            _this.orderInformation.shippingInfo.address.addressLine1 = _this.shippingAddressInfo.addressLine1;
                            _this.orderInformation.shippingInfo.address.addressLine2 = _this.shippingAddressInfo.addressLine2;
                            _this.orderInformation.shippingInfo.address.addressLine3 = _this.shippingAddressInfo.addressLine3;
                            _this.orderInformation.shippingInfo.address.addressLine4 = _this.shippingAddressInfo.addressLine4;
                            _this.orderInformation.shippingInfo.address.zipCode = _this.shippingAddressInfo.postalCode;
                            _this.orderInformation.shippingInfo.address.city = _this.shippingAddressInfo.city;
                            _this.orderInformation.shippingInfo.address.name = _this.shippingAddressInfo.shipToName;
                            _this.orderInformation.shippingInfo.address.firstName = _this.shippingAddressInfo.firstName;
                            _this.orderInformation.shippingInfo.address.middleName = _this.storeInfo && _this.storeInfo.displayMiddleName && _this.shippingAddressInfo.middleName ? _this.shippingAddressInfo.middleName : '';
                            _this.orderInformation.shippingInfo.address.lastName = _this.shippingAddressInfo.lastName;
                            _this.orderInformation.shippingInfo.address.state = _this.getStateByStateId(_this.shippingAddressInfo.stateId);
                            _this.orderInformation.shippingInfo.address.country = _this.getCountryByCountryId(_this.shippingAddressInfo.countryId);
                            _this.orderInformation.shippingInfo.address.deliveryInstruction = _this.shippingAddressInfo.deliveryInstruction;
                            _this.orderInformation.shippingInfo.address.email = _this.shippingAddressInfo.email ? _this.shippingAddressInfo.email : null;
                            _this.orderInformation.shippingInfo.address.phone = _this.shippingAddressInfo.phone ? _this.shippingAddressInfo.phone : null;
                        }
                    }
                }
                if (!_this.orderInformation.orderLineItems) {
                    _this.orderInformation.orderLineItems = new Array();
                }
                if (_this.orderInformation.orderShippings.length > 0 && _this.orderInformation.orderShippings[0].shipMethodId) {
                    _this.getShippingMethodInfo(_this.orderInformation.storeId, _this.orderInformation.orderShippings[0].shipMethodId);
                }
                var filteredCountry = _this.countries.find(function (country) {
                    return country.isocodeThree.toLowerCase() === _this.orderInformation.countryCode.toLowerCase();
                });
                var isoCodeTwo = '';
                if (filteredCountry && filteredCountry.isocodeTwo) {
                    isoCodeTwo = filteredCountry.isocodeTwo;
                }
                var postalCode = '';
                if (_this.shippingAddressInfo && _this.shippingAddressInfo.postalCode) {
                    postalCode = _this.shippingAddressInfo.postalCode.replace('-', '');
                }
                //  Generating Tracking Shipments Url
                if (_this.orderInformation.orderShippings && _this.orderInformation.orderShippings.length
                    && _this.orderInformation.orderShippings[0].shipmentId) {
                    _this.trackShipmentsURL = environment.trackShipmentsURL + '?link=1&dest_cntry=' + isoCodeTwo
                        + '&dest_postal=' + postalCode + '&tracknumbers=' + _this.orderInformation.orderNumber
                        + '&account_number=' + _this.orderInformation.orderShippings[0].shipmentId + '&cntry_code=' + isoCodeTwo;
                }
                if (_this.orderInformation.orderShippings.length > 0 && (_this.orderInformation.orderShippings[0].deliveryPreferenceId ===
                    DeliveryPreference.PICKUP || _this.orderInformation.orderShippings[0].deliveryPreferenceId ===
                    DeliveryPreference.DROPSHIP)) {
                    if (_this.orderInformation.addresses.length > 1) {
                        var address = _this.orderInformation.addresses.filter(function (item) { return item.addressType === AddressType.PUDO || item.addressType === AddressType.PICKUP; });
                        if (address) {
                            address.some(function (element) {
                                if (element && element.addressLine1) {
                                    _this.orderInformation.shippingInfo.address.addressLine1 = element.addressLine1;
                                    _this.orderInformation.shippingInfo.address.addressLine2 = element.addressLine2;
                                    _this.orderInformation.shippingInfo.address.zipCode = element.postalCode;
                                    _this.orderInformation.shippingInfo.address.city = element.city;
                                    _this.orderInformation.shippingInfo.address.name = element.name;
                                    _this.orderInformation.shippingInfo.address.state = element.stateCode;
                                    _this.orderInformation.shippingInfo.address.country = element.countryCode;
                                    _this.shipToAddressName = element.name;
                                    _this.orderInformation.shippingInfo.warehouse = element.name;
                                }
                            });
                        }
                    }
                    else {
                        _this._orderservice.getPickupAddressInformation(_this.orderInformation.orderShippings[0].shipMethodId, _this.orderInformation.storeId).subscribe(function (sresponse) {
                            if (sresponse) {
                                _this.orderInformation.shippingInfo.warehouse = sresponse.centerName;
                                _this.orderInformation.shippingInfo.address.addressLine1 = sresponse.addressDetailModel.addressLine1;
                                _this.orderInformation.shippingInfo.address.addressLine2 = sresponse.addressDetailModel.addressLine2;
                                _this.orderInformation.shippingInfo.address.zipCode = sresponse.addressDetailModel.postalCode;
                                _this.orderInformation.shippingInfo.address.city = sresponse.addressDetailModel.city;
                                _this.orderInformation.shippingInfo.address.name = sresponse.centerName;
                                _this.orderInformation.shippingInfo.address.state = sresponse.addressDetailModel.stateCode;
                                _this.orderInformation.shippingInfo.address.country = sresponse.addressDetailModel.countryCode;
                                _this.shipToAddressName = sresponse.centerName;
                            }
                        });
                    }
                }
                if (_this.orderInformation && _this.orderInformation.orderWaved != null && _this.orderInformation.orderWaved) {
                    _this.showCancelIcon = false;
                }
                if (_this.orderInformation && _this.orderInformation.orderPayments && _this.orderInformation.orderPayments.length > 0) {
                    var orderPayment = _this.orderInformation.orderPayments[0];
                    var paymentStatusId = orderPayment.paymentStatusId;
                    if (paymentStatusId && (paymentStatusId == _this.paymentStatusEnum.REFUND_INITIATED || paymentStatusId == _this.paymentStatusEnum.CANCEL_INITIATED || paymentStatusId == _this.paymentStatusEnum.CANCEL_OR_REFUND_INITITATED)) {
                        _this.showCancelIcon = false;
                    }
                }
                if (_this.orderInfo && _this.orderInfo.newOrder) {
                    if (_this.orderInformation.orderStatusId === OrderStatusEnums.Failed) {
                        var notification = _this._translatePipe.get('order.Order creation failed');
                        _this._commonService.setNotification('', notification.value, 'error', 0, false, 500);
                    }
                    else if (_this.orderInformation.orderStatusId !== OrderStatusEnums.Cancelled) {
                        var notification = _this._translatePipe.get('order.Order created successfully');
                        _this._commonService.setNotification('', notification.value, 'success', 0, false, 500);
                    }
                }
                setTimeout(function () {
                    _this.getOrderPaymentInfo(_this.orderInfo.webOrderID, _this.orderInformation.id);
                }, 300);
                _this.getDisputeTickets();
                _this.getOrderNotes();
                _this.getOrderLogs();
                _this.getShippingTrackURL(_this.orderInfo.webOrderID);
                _this._customerservice.getParticipatingCountries(_this.orderInformation.countryCode).subscribe(function (countryResponse) {
                    _this.participatingCountries = countryResponse;
                });
                // this.getMemberRegisterAddress(this.orderInformation.memberId);
                _this.disableCancelIcon();
            }
        });
    };
    /**
     * Disable Cancel Icon
     */
    RecentOrderViewComponent.prototype.disableCancelIcon = function () {
        if (((this.hasCancelPOSOrderPermission || this.hasPOSOrderRefundPermission)
            // && (this.orderStatusId.Processing == this.orderInformation.orderStatusId)
            && (this.orderStatusId.Cancelled !== this.orderInformation.orderStatusId && this.orderStatusId.Failed !== this.orderInformation.orderStatusId)
            && (this.orderInformation.source === this.orderSources.POS))) {
            this.showCancelIcon = true;
        }
        else if ((((((this.orderInformation.orderGroupId !== OrderType.REPLACEMENT)
            && (this.orderInformation.source !== this.orderSources.POS))
            && (this.hasCancelOrderPermission || this.hasRegularOrderRefundPermission))
            || (this.orderInformation.orderGroupId === OrderType.REPLACEMENT && (this.hasCancelServiceOrderPermission)))
            && (this.orderStatusId.Cancelled != this.orderInformation.orderStatusId && this.orderStatusId.Failed != this.orderInformation.orderStatusId)
            && (!this.orderInfo.tabForOrderPromotion) && this.showCancelIcon)) {
            this.showCancelIcon = true;
        }
        else {
            this.showCancelIcon = false;
        }
    };
    // getMemberRegisterAddress(memberId: any) {
    //     this._customerservice.getMemberBasicInfoById(memberId).subscribe((memberResponse) => {
    //         if (memberResponse) {
    //             this.memberBasicInfo = memberResponse;
    //         }
    //     });
    // }
    /**
     * Get Store Info
     * @param countryCode
     */
    RecentOrderViewComponent.prototype.getStoreInfo = function (country) {
        var _this = this;
        var countryCode = (country && country != '') ? country : this.orderInformation ? this.orderInformation.countryCode : null;
        if (countryCode) {
            this.appConfig = this._appConfigService.getSettings(countryCode, this.memberInfo);
            this.shippingAddressInfoConfig = this._shippingAddressInfoConfigService.getSettings(countryCode);
            this._orderservice.getStoreInfo(countryCode).subscribe(function (response) {
                if (response) {
                    _this.storeInfo = response;
                    _this.getStoreMetaData(_this.storeInfo.id);
                    _this.getOrderStatuses();
                    _this.saveAgreementDocuments(_this.orderInfo);
                    if (_this.orderInformation && _this.orderInformation.storePostedOffset === 0) {
                        if (_this.orderInformation && _this.orderInformation.createdDate !== null) {
                            _this.orderInformation.createdDate = moment.utc(_this.orderInformation.createdDate).format('DD-MMM-YYYY HH:mm:ss');
                        }
                        if (_this.orderInformation.orderPostedDate !== null) {
                            _this.orderInformation.orderPostedDate = moment.utc(_this.orderInformation.orderPostedDate).format('DD-MMM-YYYY HH:mm:ss');
                        }
                    }
                    else {
                        if (_this.orderInformation && _this.orderInformation.createdDate !== null && _this.orderInformation.storePostedOffset) {
                            _this.orderInformation.createdDate = moment.utc(_this.orderInformation && _this.orderInformation.createdDate)
                                .utcOffset(_this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                        }
                    }
                    if (_this.orderInformation && _this.orderInformation.orderPostedDate !== null && _this.orderInformation.storePostedOffset) {
                        _this.orderInformation.orderPostedDate = moment.utc(_this.orderInformation && _this.orderInformation.orderPostedDate)
                            .utcOffset(_this.orderInformation.storePostedOffset).format('DD-MMM-YYYY HH:mm:ss');
                    }
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order. Unable to fetch Store Details');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
    };
    /*
    get Dispute Tickets created on selected web order Id.
     */
    RecentOrderViewComponent.prototype.getDisputeTickets = function () {
        var _this = this;
        var weborderId = this.orderInfo.webOrderID ? this.orderInfo.webOrderID : this.orderInfo.orderNumber;
        this._customerservice.SearchTicketsOnPagination(null, null, null, null, null, null, null, null, null, this.ticketsPageNumber, this.ticketsPageSize, this.ticketsSortColumn, this.ticketsSort, weborderId).subscribe(function (response) {
            if (response) {
                _this.tickets = response["content"];
                _this.ticketsPageCount = response['totalCount'];
            }
            else {
                _this.tickets = [];
                _this.ticketsPageCount = 0;
            }
        });
    };
    /**
 * sorting of columns // not hits service...
 * @param sortColumn
 */
    RecentOrderViewComponent.prototype.sortOrderInformationByColumn = function (sortColumn) {
        var _this = this;
        var productitems;
        productitems = this.orderInformation.productInfo;
        this.isDesc = (this.sortColumn == sortColumn || sortColumn == "") ? !this.isDesc : this.isDesc;
        productitems.sort(function (a, b) {
            if (a[sortColumn] > b[sortColumn])
                return _this.isDesc ? -1 : 1;
            if (a[sortColumn] < b[sortColumn])
                return _this.isDesc ? 1 : -1;
        });
        this.sortColumn = sortColumn;
    };
    /*
      sort dispute tickets by column
       */
    RecentOrderViewComponent.prototype.sortTicketsByColumn = function (sortColumn) {
        this.ticketsIsDesc = (this.ticketsSortColumn == sortColumn) ? !this.ticketsIsDesc : this.ticketsIsDesc;
        this.ticketsSort = this.ticketsIsDesc ? "DESC" : "ASC";
        this.ticketsSortColumn = sortColumn;
        //added this condition not to hit service if there are no items in grid.
        if (this.tickets.length === 0) {
            return;
        }
        this.getDisputeTickets();
        this.getOrderNotes();
        this.getOrderLogs();
    };
    /*
   get dispute tickets on page change
    */
    RecentOrderViewComponent.prototype.ticketsPageChange = function (pageNumber) {
        if (!isNaN(pageNumber)) {
            this.ticketsPageNumber = pageNumber;
            this.getDisputeTickets();
            this.getOrderNotes();
            this.getOrderLogs();
        }
    };
    /*
      * To update tickets in the order history once updated
    */
    RecentOrderViewComponent.prototype.subscribeDisputeTickets = function () {
        var _this = this;
        this.messageService.getDisputeTickets().subscribe(function (data) {
            if (data) {
                _this.getDisputeTickets();
                _this.getOrderNotes();
                _this.getOrderLogs();
            }
        });
    };
    RecentOrderViewComponent.prototype.getOrderPaymentInfo = function (webOrderId, orderId) {
        var _this = this;
        this._customerservice.getPaymentInfo(webOrderId, orderId).subscribe(function (response) {
            if (response) {
                _this.paymentInfo = true;
                _this.orderInformation.billingInfo = response;
                _this.achPaymentInfo = response;
            }
            //if(this.achPaymentInfo.dlState){
            //this.getStateByStateCodeAndCountryCode(this.achPaymentInfo.dlState,this.orderInformation.countryCode)
            // }
            _this.showPrintOption = true;
        }, function (error) {
            _this.paymentInfo = false;
            _this.showPrintOption = true;
        });
    };
    /*create new ticket*/
    RecentOrderViewComponent.prototype.createDisputeTicket = function () {
        if (this.isTicketCreate) {
            var ticketTab = new TicketTabInfo();
            ticketTab.distributorID = this.fboid;
            ticketTab.isNewTicket = true;
            ticketTab.title = "Create Ticket";
            ticketTab.country = this.orderInfo.homeCountry;
            ticketTab.webOrderID = this.orderInfo.webOrderID || this.orderInfo.orderID;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        }
        else {
            this.displayAlertbox();
        }
        //this.tabId++;
    };
    /*
      view or edit Dispute tickets in new tab
       */
    RecentOrderViewComponent.prototype.goToViewTicket = function (id, ticketNumber) {
        if (this.isTicketView) {
            var ticketTab = new TicketTabInfo();
            ticketTab.distributorID = this.distributorInfo.distributorId;
            ticketTab.isNewTicket = false;
            ticketTab.ticketID = id;
            ticketTab.title = "View Ticket - " + ticketNumber;
            ticketTab.viewTicket = true;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        }
        else {
            this.displayAlertbox();
        }
    };
    /**
       * display alert box if the logged in user do not have permission to see the fbo/retail information
       */
    RecentOrderViewComponent.prototype.displayAlertbox = function () {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    };
    RecentOrderViewComponent.prototype.doNotRemoveFormData = function () {
        //data should not be removed...
    };
    /*
    get different order statuses
     */
    RecentOrderViewComponent.prototype.getOrderStatuses = function () {
        var _this = this;
        Object.entries(OrderStatuses).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            return _this.orderStatuses.push({ id: +value, description: key });
        });
        this.getRecentOrderInformation();
    };
    RecentOrderViewComponent.prototype.saveAgreementDocuments = function (orderIndo) {
        var _this = this;
        if (orderIndo && orderIndo.acceptDocuments && orderIndo.acceptDocuments.memberTypeId
            && orderIndo.acceptDocuments.memberId && orderIndo.acceptDocuments.documents
            && orderIndo.acceptDocuments.documents.length) {
            orderIndo.acceptDocuments.documents.forEach(function (document) {
                _this._documentService.updateAcknowledgedDocuments(document, orderIndo.acceptDocuments.memberTypeId, orderIndo.acceptDocuments.memberId).subscribe(function (res) {
                });
            });
        }
    };
    /**
     * get billing information
     * @param addressId
     */
    RecentOrderViewComponent.prototype.getAddressInfo = function (addressId, billingAddressId) {
        var _this = this;
        this._orderservice.getBillingInfo(addressId).subscribe(function (response) {
            if (response.length > 0 && !billingAddressId) {
                _this.orderInformation.shippingInfo.address.addressLine1 = response[0].addressLine1;
                _this.orderInformation.shippingInfo.address.addressLine2 = response[0].addressLine2;
                _this.orderInformation.shippingInfo.address.zipCode = response[0].postalCode;
                _this.orderInformation.shippingInfo.address.city = response[0].city;
                _this.orderInformation.shippingInfo.address.name = response[0].shipToName;
                _this.orderInformation.shippingInfo.address.state = _this.getStateByStateId(response[0].stateId);
                _this.orderInformation.shippingInfo.address.country = _this.getCountryByCountryId(response[0].countryId);
            }
        });
    };
    /**
     * Get State Info by Code or Id
     * @param stateId
     *
     */
    RecentOrderViewComponent.prototype.getStateByStateId = function (stateId) {
        var stateName = "";
        if (stateId) {
            var stateObj = this.states.find(function (x) { return x.id === stateId; });
            stateName = stateObj ? stateObj.stateName : '';
        }
        return stateName;
    };
    /**
     * get States
     */
    RecentOrderViewComponent.prototype.getStates = function () {
        var _this = this;
        this._customerservice.getStates().subscribe(function (response) {
            if (response) {
                _this.states = response;
            }
        });
    };
    /**
    * Get Country Info by Code or Id
    * @param countryId
    *
    */
    RecentOrderViewComponent.prototype.getCountryByCountryId = function (countryId) {
        var countryName = "";
        if (countryId) {
            var countryObj = this.countries.find(function (x) { return x.countryId === countryId; });
            countryName = countryObj ? countryObj.name : '';
        }
        return countryName;
    };
    /**
  * get Countries
  */
    RecentOrderViewComponent.prototype.getCountries = function () {
        var allCountries = JSON.parse(localStorage.getItem("appadmin.Countries"));
        if (allCountries) {
            this.countries = allCountries;
        }
    };
    /**
     * edit order
     */
    RecentOrderViewComponent.prototype.editOrder = function () {
        var orderUrl = window.location.origin + '/customerservice/orders/' + this.orderInfo.webOrderID.toUpperCase();
        window.open(orderUrl, "_blank");
    };
    /**
    * clone order
    */
    RecentOrderViewComponent.prototype.cloneOrder = function () {
        var orderUrl = window.location.origin + '/customerservice/orders/' + this.orderInfo.webOrderID.toUpperCase();
        window.open(orderUrl, "_blank");
    };
    RecentOrderViewComponent.prototype.getShippingMethodInfo = function (storeId, shippingMethodId) {
        var _this = this;
        this._orderservice.getShippingMethod(storeId, shippingMethodId).subscribe(function (response) {
            if (response) {
                var shipmentMethod = response;
                _this.orderInformation.shippingInfo.shippingMethod = shipmentMethod.shippingMethodDisplayName ? shipmentMethod.shippingMethodDisplayName : 'NA';
            }
        });
    };
    /**
     * To Disable the Cancel Checkbox based on the perission
     */
    RecentOrderViewComponent.prototype.disabledCancelCheckbox = function () {
        var paymentMethodResult = this.isNotRefundablePayments();
        var isDisabledCancelCheckbox = false;
        var isDisabledCancelAndRefundCheckbox = false;
        var cancelElement = document.getElementById('cancel');
        var cancelAndRefundElement = document.getElementById('cancelAndRefund');
        if ((!((this.hasCancelOrderPermission && this.orderInformation.source !== Constants.POS_ORDER && this.orderInformation.orderGroupId !== OrderType.REPLACEMENT) ||
            (this.orderInformation.source === Constants.POS_ORDER && this.hasCancelPOSOrderPermission) ||
            (this.orderInformation.orderGroupId === OrderType.REPLACEMENT && this.hasCancelServiceOrderPermission)))) {
            if (cancelElement) {
                cancelElement.disabled = true;
                isDisabledCancelCheckbox = true;
            }
        }
        if ((!((!(paymentMethodResult) && this.hasRegularOrderRefundPermission && this.orderInformation.source !== Constants.POS_ORDER && this.orderInformation.orderGroupId != OrderType.REPLACEMENT) ||
            (this.orderInformation.source === Constants.POS_ORDER && this.hasPOSOrderRefundPermission) ||
            (this.orderInformation.orderGroupId === OrderType.REPLACEMENT)))) {
            if (cancelAndRefundElement) {
                cancelAndRefundElement.disabled = true;
                isDisabledCancelAndRefundCheckbox = true;
            }
        }
        if ((paymentMethodResult == false)) {
            if (cancelAndRefundElement && (!(cancelAndRefundElement.disabled))) {
                if (this.paymentAmount > this.refundAmount) {
                    cancelAndRefundElement.disabled = false;
                    if (isDisabledCancelCheckbox == true) {
                        isDisabledCancelAndRefundCheckbox = false;
                    }
                    else {
                        isDisabledCancelAndRefundCheckbox = true;
                    }
                }
                else {
                    cancelAndRefundElement.disabled = true;
                    isDisabledCancelAndRefundCheckbox = true;
                }
            }
        }
        else if ((paymentMethodResult == true) && (cancelAndRefundElement)) {
            cancelAndRefundElement.disabled = true;
            isDisabledCancelAndRefundCheckbox = true;
        }
        if (cancelElement && cancelAndRefundElement) {
            if (!isDisabledCancelCheckbox && isDisabledCancelAndRefundCheckbox) {
                cancelElement.checked = true;
                this.onCancelOptionChange('cancel');
            }
            else if (isDisabledCancelCheckbox && !isDisabledCancelAndRefundCheckbox) {
                cancelAndRefundElement.checked = true;
                this.onCancelOptionChange('cancelAndRefund');
            }
            else if (!isDisabledCancelCheckbox && !isDisabledCancelAndRefundCheckbox) {
                cancelElement.checked = true;
                this.onCancelOptionChange('cancel');
            }
        }
    };
    /**
     * To Check whether Refundable payments or not.
     */
    RecentOrderViewComponent.prototype.isNotRefundablePayments = function () {
        var paymentType = this.orderInformation && this.orderInformation.billingInfo
            && this.orderInformation.billingInfo.paymentMethod ? this.orderInformation.billingInfo.paymentMethod : '';
        if (paymentType.toLowerCase() === this.paymentType.Cash.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Credit_Card_External.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Cash_On_Delivery.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Bank_Transfer.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Money_order.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Orange_Money.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Wire_Transfer.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Personal_Check.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Travelers_Check.toLowerCase() ||
            // paymentType.toLowerCase() === this.paymentType.Credit_Card.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Integrated_Terminal_Adyen.toLowerCase() ||
            paymentType.toLowerCase() === this.paymentType.Bonus_Check.toLowerCase()) {
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Show cancel Order
     */
    RecentOrderViewComponent.prototype.cancelOrderPopup = function () {
        this.buildForm();
        this.getOrderStatusChangeReason();
        this.getBonusRunStatusDetails("cancelOrder");
    };
    RecentOrderViewComponent.prototype.openCancelOrderPopup = function () {
        var _this = this;
        if (this.bonusDetails && this.bonusDetails.success && (this.bonusDetails.bonusStatusId == BonusStatus.OPEN || this.bonusDetails.bonusStatusId == BonusStatus.RESTRICTED)) {
            this.cancelOrderModal.open();
            setTimeout(function () {
                var orderCancelNotesElement = document.getElementById("orderStatusChangeReasonId");
                if (orderCancelNotesElement) {
                    orderCancelNotesElement.focus();
                }
                _this.disabledCancelCheckbox();
            }, 200);
        }
        else {
            this.toasterMsg("common.The bonus run status for this order's processing period is not open or restricted.", NotificationType.ERROR);
        }
    };
    /**
     * Get order status change reason based on operating country
     */
    RecentOrderViewComponent.prototype.getOrderStatusChangeReason = function () {
        var _this = this;
        this._orderservice.getChangeReasons(null, null, true, null, null, null, this.storeInfo.operatingCountry).subscribe(function (response) {
            if (response && response.totalCount > 0) {
                _this.orderStatusChangeReasons = response.content;
                _this.orderStatusChangeReasons.sort(function (a, b) {
                    if (a.reasonNote < b.reasonNote) {
                        return -1;
                    }
                    else if (a.reasonNote > b.reasonNote) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                });
            }
            else {
                _this.orderStatusChangeReasons = [];
            }
        }, function () {
            _this.orderStatusChangeReasons = [];
        });
    };
    // Method for calculating the shipping cost with and without shipping tax
    // getShippingCostWithShippingTax() {
    //     // this.getVatIdfromMember();
    //     const skipShippingTaxCalculation = (this.memberInfo && this.memberInfo.vatRegistered) || this.appConfig.skipShippingTaxCalculationInShipping ;
    //     if (this.orderInformation && this.appConfig) {
    //         if (this.memberInfo && ((this.memberInfo.vatRegistered && this.orderInformation.vatRegistered) || (this.appConfig.enableVatItemizationForNonVat && this.memberInfo.memberTypeId === this.memberTypeEnums.DISTRIBUTOR)) || (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice
    //             && !this.appConfig.calculateShippingWithTax)) {
    //             this.shippingCost = this.orderInformation.shippingCost;
    //         } else if (this.appConfig.calculateShippingWithTax || (!skipShippingTaxCalculation && this.orderInformation.shippingTax && !this.appConfig.enableVatItemizationForNonVat)) {
    //             this.shippingCost =  this.orderInformation.orderShippings.length > 0 && this.orderInformation.orderShippings[0].shippingWaived ?  this.orderInformation.shippingCost : this.orderInformation.shippingCost + this.orderInformation.shippingTax;
    //         } else {
    //             this.shippingCost =  this.orderInformation.orderShippings.length > 0 && this.orderInformation.orderShippings[0].shippingWaived ? this.orderInformation.shippingCost :  this.orderInformation.shippingCost;
    //         }
    //     }
    // }
    RecentOrderViewComponent.prototype.getShippingCostWithShippingTax = function () {
        if (this.orderInformation && this.appConfig) {
            if (this.memberInfo && ((this.orderInformation.vatRegistered) || (this.appConfig.enableVatItemizationForNonVat && this.orderInformation.memberTypeId === this.memberTypeEnums.DISTRIBUTOR)) || (this.checkoutConfig && this.checkoutConfig.calculateTaxExclusivePrice)
                && !this.appConfig.calculateShippingWithTax) {
                this.shippingCost = this.orderInformation.shippingCost;
            }
            else if (this.appConfig.calculateShippingWithTax) {
                this.shippingCost = this.orderInformation.orderShippings[0].shippingWaived ? this.orderInformation.shippingCost : this.orderInformation.shippingCost + this.orderInformation.shippingTax;
            }
            else {
                this.shippingCost = this.orderInformation.shippingCost;
            }
        }
    };
    /**
     * Build Form for cancel orders
     */
    RecentOrderViewComponent.prototype.buildForm = function () {
        this.orderCancelForm = this._formbuilder.group({
            cancelAndRefund: [''],
            orderStatusChangeReasonId: ['', [Validators.required]],
            notes: ['']
        });
    };
    /**
     * close cancel order popup
     */
    RecentOrderViewComponent.prototype.closePopup = function () {
        this.cancelOrderModal.close();
        this.cancelOrderResponseModal.close();
    };
    /**
    * cancel order
    */
    RecentOrderViewComponent.prototype.cancelOrder = function () {
        var _this = this;
        if (this.orderCancelForm.valid && (this.orderCancelForm.value.notes.trim().length > 0 || this.orderCancelForm.value.orderStatusChangeReasonId)) {
            var notes_1 = this.orderCancelForm.value.notes;
            var orderStatusChangeReasonId_1 = this.orderCancelForm.value.orderStatusChangeReasonId;
            this.cancelOrderModal.close();
            this._orderservice.cancelOrder(this.orderInfo.webOrderID, this.isCancelAlone).subscribe(function (response) {
                if (response && response.success) {
                    if (_this.bonusDetails &&
                        ((_this.isCancelAlone &&
                            (_this.bonusDetails.bonusStatusId == BonusStatus.OPEN ||
                                _this.bonusDetails.bonusStatusId == BonusStatus.CLOSED_AND_PUBLISHED)) ||
                            (!_this.isCancelAlone && _this.bonusDetails.bonusStatusId == BonusStatus.OPEN))) {
                        _this.cancelOrderResponseModal.open();
                    }
                    if ((_this.orderInformation && _this.orderInformation.orderPayments && _this.orderInformation.orderPayments.length > 0)
                        && _this.orderInformation.orderStatusId !== 1
                        && (_this.orderInformation.orderPayments[0].paymentMode === PaymentMethodTypes.eCheck
                            || _this.orderInformation.orderPayments[0].paymentMode === PaymentMethodTypes.Money_order
                            || _this.orderInformation.orderPayments[0].paymentMode === PaymentMethodTypes.Orange_Money
                            || _this.orderInformation.orderPayments[0].paymentMode === PaymentMethodTypes.Wire_Transfer)) {
                        _this.createTicket(notes_1, _this.orderInformation.orderPayments[0].paymentMode);
                    }
                    var orderStatusChangeReason = _this.orderStatusChangeReasons.filter(function (reasonNote) { return reasonNote.id == orderStatusChangeReasonId_1; });
                    _this.createOrderNote(_this.orderInfo.webOrderID, orderStatusChangeReason[0].reasonNote, false, orderStatusChangeReasonId_1, notes_1);
                    _this.showCancelIcon = false;
                    var notificationMessage = 'order.Order cancelled sucessfully';
                    if (response.orderStatusId != _this.orderStatusId.Cancelled) {
                        notificationMessage = 'order.Order cancel/refund initiated successfully, Please check the order logs for updated status at later time';
                    }
                    var notification = _this._translatePipe.get(notificationMessage);
                    _this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
                    _this.getRecentOrderInformation();
                }
                else if (response && !response.success && response.validations && response.validations.length > 0) {
                    _this._commonService.createNotification('', response.validations[0].message, NotificationType.ERROR);
                }
                else {
                    var notification = _this._translatePipe.get('order.Unable to cancel Order');
                    _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
                }
            }, function (error) {
                var notification = _this._translatePipe.get('order.Unable to cancel Order');
                _this._commonService.createNotification('', notification.value, NotificationType.ERROR);
            });
        }
        else {
            var notification = this._translatePipe.get('order.Reason is Mandatory');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
    };
    RecentOrderViewComponent.prototype.showNotification = function (response) {
        if (response && response.success) {
            var notification = this._translatePipe.get('order.Order Notes Created sucessfully');
            this._commonService.createNotification('', notification.value, NotificationType.SUCCESS);
            this.getOrderNotes();
            this.getOrderLogs();
        }
        else {
            var notification = this._translatePipe.get('order.Order Note creation has been failed');
            this._commonService.createNotification('', notification.value, NotificationType.ERROR);
        }
    };
    RecentOrderViewComponent.prototype.getOrderNotes = function () {
        var _this = this;
        if (this.orderInfo && this.orderInfo.webOrderID) {
            this._orderservice.getOrderNotes(this.orderInfo.webOrderID).subscribe(function (response) {
                if (response) {
                    _this.orderNotes = response;
                    _this.orderNotes.forEach(function (note) {
                        if (note.createdDate) {
                            note.dateFormat = moment(note.createdDate).utcOffset(_this.storeInfo.timeZoneOffset).format('DD-MMM-YYYY');
                            note.hoursFormat = moment(note.createdDate).utcOffset(_this.storeInfo.timeZoneOffset).format('HH:mm:ss');
                        }
                    });
                }
            });
        }
    };
    RecentOrderViewComponent.prototype.getOrderLogs = function () {
        var _this = this;
        if (this.orderInfo && this.orderInfo.webOrderID) {
            this._orderservice.getOrderLogs(this.orderInfo.webOrderID).subscribe(function (response) {
                if (response) {
                    _this.orderLogs = response;
                    if (_this.orderLogs && _this.orderLogs.length > 0) {
                        _this.orderLogs.forEach(function (x) {
                            if (x.date && _this.orderInformation && (_this.orderInformation.storePostedOffset || _this.orderInformation.storePostedOffset === 0)) {
                                x.dateFormat = moment(x.date).utcOffset(_this.orderInformation.storePostedOffset).format('DD-MMM-YYYY');
                                x.hoursFormat = moment(x.date).utcOffset(_this.orderInformation.storePostedOffset).format('HH:mm:ss');
                            }
                        });
                        console.log(_this.orderLogs);
                        var index = _this.orderLogs.findIndex(function (x) { return x.messageTypeId == _this.AcknowledgeType; });
                        if (index > -1) {
                            _this.systemOrderNumberAcknowledgedFromAs400 = true;
                        }
                    }
                }
            });
        }
    };
    /**
     * create order cancel ticket
     */
    RecentOrderViewComponent.prototype.createTicket = function (notes, paymentMode) {
        this.getTicketTypesAndSubTypes();
        this.getDepartments();
        var ticket = new CreateTicketRequest();
        ticket.sourceId = SourceType.Email;
        ticket.callerName = this.distributorInfo ? this.distributorInfo.name : (this.memberInfo ? this.memberInfo.firstName : this.fboid);
        ticket.operatingCountryId = this.operatingCountry;
        ticket.typeId = this.ticketTypeId ? this.ticketTypeId : Types.Order;
        ticket.subTypeId = SubtypesEnums.Cancel_Order;
        ticket.description = "Order - " + this.orderInformation.webOrderId + " placed using  " + paymentMode + ", cancelled by " + this.userInfo.firstName + " " + this.userInfo.lastName;
        ticket.departmentId = this.departmentId ? (+this.departmentId) : 0;
        ticket.priorityId = Priority.Medium;
        ticket.dueDate = null;
        ticket.subject = "Order - " + this.orderInformation.webOrderId + " cancelled";
        ticket.assignedToId = 0;
        ticket.memberId = (this.distributorInfo && this.distributorInfo.distributorId) ? this.distributorInfo.distributorId : this.fboid;
        ticket.memberType = MemberType.FOB;
        ticket.userId = this.userInfo.userId;
        ticket.firstName = this.userInfo.firstName;
        ticket.lastName = this.userInfo.lastName;
        ticket.sourceIdentifierValue = this.distributorInfo && this.distributorInfo.email ? this.distributorInfo.email : '';
        if (((this.orderInformation.billingInfo.paymentMethod === this.paymentType.Wire_Transfer) || (this.orderInformation.billingInfo.paymentMethod === this.paymentType.Money_order) || (this.orderInformation.billingInfo.paymentMethod === this.paymentType.Orange_Money) || (this.orderInformation.billingInfo.paymentMethod === this.paymentType.eCheck) || (this.orderInformation.billingInfo.paymentMethod === this.paymentType.Ach)) && ((this.orderInformation.orderStatusId === OrderStatusEnums.Accepted) || (this.orderInformation.orderStatusId === OrderStatusEnums.Review_Window))) {
            ticket.statusId = Status.New;
        }
        else {
            ticket.statusId = Status.Closed;
        }
        ticket.orderId = this.orderInformation.webOrderId;
        ticket.note = notes;
        this.saveTicket(ticket);
    };
    RecentOrderViewComponent.prototype.saveTicket = function (saveTicket) {
        this._customerservice.saveTicket(saveTicket).subscribe(function (response) {
        });
    };
    RecentOrderViewComponent.prototype.getDepartments = function () {
        var _this = this;
        this._customerservice.getAllDepartmentsByOperatingCountryId(this.operatingCountry).subscribe(function (response) {
            if (response && response.length > 0) {
                _this.departmentId = response[0].id;
            }
        });
    };
    /**
     * get member information for member type
     */
    RecentOrderViewComponent.prototype.getMemberInformation = function () {
        var _this = this;
        var type = '';
        var memberDetail = '';
        if (this.orderInformation) {
            memberDetail = this.orderInformation.distrubutorId ? this.orderInformation.distrubutorId :
                this.orderInformation.email;
        }
        type = memberDetail ? memberDetail.indexOf('@') > -1 ? 'email' : 'fboId' : null;
        this._customerservice.getMemberDetails(memberDetail, type).subscribe(function (response) {
            if (response && response.memberId) {
                // this.getMembergovernmentIdentificationsInfo(response.memberId);
                _this.isTitanEnabled = response.isSuccess;
                _this.memberId = response.memberId;
                _this.memberStatus = response.memberStatus;
                _this.maxlimit--;
                _this.getMemberLevelInfo(response);
                //When AS400 is down
                if (!response.fboId) {
                    _this._commonService.getMemberInfoByMemberId(_this.orderInformation.memberId).subscribe(function (res) {
                        if (res && res[0]) {
                            _this.memberInfo.fboId = res[0].code;
                            if (!res[0].code && _this.maxlimit === 0) {
                                _this.getMemberInformation();
                            }
                        }
                    }, function (error) { });
                }
            }
        });
    };
    RecentOrderViewComponent.prototype.getMemberLevelInfo = function (memberResponse) {
        this.processMemberResponse(memberResponse);
        this.getShippingCostWithShippingTax();
        // this._commonService.getMemberLevelDetails(memberResponse.fboId).subscribe((response) => {
        //     if (response && response.memberLevel) {
        //         memberResponse.memberTitle = response.memberLevel;
        //     }
        //     this.processMemberResponse(memberResponse);
        // }, (error) => {
        //     this.processMemberResponse(memberResponse);
        // });
    };
    /**
     * @description
     * @date 2020-09-09
     * @param {*} response
     */
    RecentOrderViewComponent.prototype.processMemberResponse = function (response) {
        var _this = this;
        this.memberInfo = response;
        if (this.storeInfo && this.memberInfo) {
            this.memberInfo.displayMiddleName = this.storeInfo.displayMiddleName;
        }
        // this.memberInfo.privacyRequested = this._commonService.isPrivacyRequested(response.memberPreferences);
        if (+this.memberInfo.memberTypeId !== MemberTypeEnum.DISTRIBUTOR) {
            this.memberInfo.vatRegistered = false;
        }
        var countryObj = this.countries.find(function (x) { return x.isocodeThree.toLowerCase()
            === _this.orderInformation.countryCode.toLowerCase(); });
        if (this.memberInfo && countryObj) {
            this.memberInfo.vatRegistered = this._commonService.getVatDetail(countryObj, this.memberInfo);
        }
        this.appConfig = this._appConfigService.getSettings(this.orderInfo.homeCountry, this.memberInfo);
        this.displayOrderVatTax();
        this.memberTypeId = this.memberInfo.memberTypeId;
        if (this.memberInfo && (+this.memberInfo.memberTypeId === MemberTypeEnum.GUEST)) {
            this.memberInfo.memberTitle = MemberType.GUEST;
        }
        else if (+response.memberTypeId === MemberTypeEnum.FPC) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        if (this.memberInfo && this.memberInfo.memberTypeId === MemberTypeEnum.DISTRIBUTOR && this.memberInfo.memberTitleId === MemberLevel.NOVICCUSTOMER) {
            this.memberInfo.memberTitle = MemberType.PREFERREDCUSTOMER;
        }
        this.showCCSnapshot = true;
    };
    RecentOrderViewComponent.prototype.displayOrderVatTax = function () {
        var _this = this;
        if (this.appConfig.enableVATCalculation && this.appConfig.displayVat && this.orderInformation) {
            if (this.orderInformation.orderTypeId === PurchaseFlow.Enrollment && this.orderInformation.initialOrder
                && this.orderInformation.vatRegistered) {
                this.appConfig.displayVat = true;
            }
            else if (this.shippingAddressInfo && this.shippingAddressInfo.countryId && this.participatingCountries
                && this.participatingCountries.length && this.orderInformation.vatRegistered) {
                var country = this.participatingCountries
                    .find(function (x) { return x.countryId === _this.shippingAddressInfo.countryId; });
                this.appConfig.displayVat = this.getCountryTaxInclusiveInfo(country);
            }
            else {
                this.appConfig.displayVat = false;
            }
        }
        else if (this.appConfig.displayVat && !this.appConfig.enableVATCalculation) {
            this.appConfig.displayVat = true;
        }
        else {
            this.appConfig.displayVat = false;
        }
    };
    RecentOrderViewComponent.prototype.getCountryTaxInclusiveInfo = function (country) {
        var countryTaxInclusive = false;
        if (country && country.countryMetadata &&
            country.countryMetadata.length > 0 &&
            country.countryMetadata[0].metadata) {
            countryTaxInclusive = (country.countryMetadata[0].metadata[0].value === 'TRUE') ? true : false;
        }
        return countryTaxInclusive;
    };
    /**
     * @description To get the card image
     * @date 2018-08-27
     * @param {*} cardType
     * @returns {string}
     * @memberof PaymentComponent
     */
    RecentOrderViewComponent.prototype.getImagePath = function (cardType) {
        var cardTypeImage;
        if (cardType) {
            switch (true) {
                case cardType.toUpperCase() === PaymentCardTypes.VISA:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/visa.png';
                    break;
                case (cardType.toUpperCase() === PaymentCardTypes.MASTER
                    || cardType.toUpperCase() === PaymentCardTypes.MASTER_WORLDPAY
                    || cardType.toUpperCase() === PaymentCardTypes.MASTERCARD):
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/mastercard.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.AMEX:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/amercianexpress.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.MAESTRO:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/maestro.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DINERS:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/dinner-club.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.JCB:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/jcb.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DISCOVER:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/discovernetwork.png';
                    break;
                default:
                    cardTypeImage = null;
                    break;
            }
        }
        return cardTypeImage;
    };
    /**
    * create order log request parameter
    */
    RecentOrderViewComponent.prototype.createOrderLog = function (orderLog) {
        var _this = this;
        var orderLogRequest = {
            "messageTypeId": MessageTypeEnum.OrderLogsMessageType,
            "orderId": this.orderInformation.id,
            "webOrderId": this.orderInformation.webOrderId,
            "message": orderLog,
            "source": Constants.CUSTOMER_SERIVCE
        };
        this._orderservice.createOrderLog(orderLogRequest)
            .subscribe(function (response) {
            _this.getRecentOrderInformation();
        }, function (error) {
            _this._commonService.createNotification('', 'Failed to create order log', NotificationType.ERROR);
        });
    };
    RecentOrderViewComponent.prototype.getShippingTrackURL = function (webOrderId) {
        var _this = this;
        //webOrderId ="USA0000001";
        this._orderservice.getShippingTrackingURL(webOrderId).subscribe(function (response) {
            if (response) {
                _this.shipTrackingUrl = response.shipmentTrackingUrl;
            }
        });
    };
    /**
     * Show Order Notes Modal
     */
    RecentOrderViewComponent.prototype.openCreateNotesModal = function () {
        this.buildOrderNotesForm();
        // this._commonService.jumpingScroll(true);
        this.orderNotesModal.open();
    };
    /**
     * Build Form for Order Notes
     */
    RecentOrderViewComponent.prototype.buildOrderNotesForm = function () {
        this.orderNotesForm = this._formbuilder.group({
            ordernotes: ['', [Validators.required]]
        });
    };
    /**
     * close order notes popup
     */
    RecentOrderViewComponent.prototype.closeOrderNotesPopup = function () {
        this.orderNotesModal.close();
        // this._commonService.jumpingScroll(false);
    };
    /**
    * Add Notes
    */
    RecentOrderViewComponent.prototype.AddNotes = function () {
        if (this.orderNotesForm.valid && this.orderNotesForm.value.ordernotes.trim().length > 0) {
            var notes = this.orderNotesForm.value.ordernotes;
            this.orderNotesModal.close();
            // this._commonService.jumpingScroll(false);
            this.createOrderNote(this.orderInfo.webOrderID, notes, true);
        }
    };
    /**
      *
      * @param items
      */
    RecentOrderViewComponent.prototype.getItemVolumeSum = function (items) {
        if (this.appConfig.roundoffTaxAmount) {
            return Math.round(items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; }));
        }
        else {
            return items
                .map(function (x) { return x.taxAmount; })
                .reduce(function (a, b) { return a + b; });
        }
    };
    RecentOrderViewComponent.prototype.trackByItem = function (index) {
        return index;
    };
    /**
    * edit order
    */
    RecentOrderViewComponent.prototype.printOrder = function () {
        var _this = this;
        var oldTitle = this.documentRef.title;
        this.documentRef.title = this._translatePipe.get('orderdetails.Forever Living Products')['value'];
        this.showprint = true;
        setTimeout(function () {
            window.print();
            if (window.navigator.userAgent.toLowerCase().indexOf('safari') > -1) {
                setTimeout(function () {
                    _this.showprint = false;
                }, 3000);
            }
            else {
                _this.showprint = false;
            }
            _this.documentRef.title = oldTitle;
        }, 1000);
    };
    RecentOrderViewComponent.prototype.getStoreMetaData = function (storeId) {
        var _this = this;
        this._commonService.getStoreMetaData(storeId)
            .subscribe(function (storeMetaData) {
            _this.storeMetadata = storeMetaData;
        });
    };
    RecentOrderViewComponent.prototype.createNewServiceOrder = function () {
        if ((!this.isTitanEnabled) || this.memberStatus && (this.memberStatus.id === +MemberStatus.Active)) {
            var CreateOrderInfo = {
                distributorId: this.fboid,
                webOrderId: this.orderInfo.webOrderID,
                countryId: this.orderInformation.countryCode
            };
            this._cacheService.set(CacheKey.CREATE_SERVICE_ORDER_INFO_SESSION_CODE, CreateOrderInfo);
            this._cacheService.set(CacheKey.IsServiceOrder, true);
        }
        else {
            this.memberRestrictions.open();
            return false;
        }
    };
    /**
     * Get State Info by stateCode and countryCode
     * @param stateCode
     * @param countryCode
     *
     */
    RecentOrderViewComponent.prototype.getStateByStateCodeAndCountryCode = function (stateCode, countryCode) {
        var stateName = "";
        if (stateCode && countryCode) {
            var stateObj = this.states.find(function (x) { return x.stateCode === stateCode && x.countryCode === countryCode; });
            stateName = stateObj ? stateObj.stateName : '';
            this.orderInformation.billingInfo.dlState = stateName;
        }
        return stateName;
    };
    RecentOrderViewComponent.prototype.fetchEcheckSecTypes = function (secType) {
        if (secType === SecType.Web) {
            return 'WEB ACH';
        }
        else {
            return 'PPD ACH';
        }
    };
    RecentOrderViewComponent.prototype.onCancelOptionChange = function (value) {
        this.isCancelAlone = value && value.toLowerCase() === cancelOrderOptions.CANCEL.toLowerCase() ? true : false;
    };
    RecentOrderViewComponent.prototype.changeDistributorIdForAnExistingOrder = function () {
        this.isMemberSearchSucess = false;
        this.FboIDSearchForm = this._formbuilder.group({
            distributorID: ['', Validators.required]
        });
        this.onValueChanges();
        this.updateFboIdOfAnOrderModal.open();
    };
    RecentOrderViewComponent.prototype.closeupdateFboIdOfAnOrderModalPopup = function (isReset) {
        if (isReset) {
            this.distributorIDofValenceSearch = '';
            this.isMemberSearchSucess = false;
            this.FPCOrFBONotFoundErrorMessage = false;
            this.errorMessage = false;
            this.distributorDetailsForValenceSearch = null;
            this.isNotAuthorizedCountry = false;
        }
        this.updateFboIdOfAnOrderModal.close();
    };
    RecentOrderViewComponent.prototype.onSubmitFboSearchForm = function (isValidForm) {
        var _this = this;
        if (isValidForm) {
            this.distributorIDofValenceSearch = this.FboIDSearchForm.get('distributorID').value;
            if (!this.isMemberSearchSucess) {
                this.distributorDetailsForValenceSearch = null;
                this.isMemberSearchSucess = false;
                this.FPCOrFBONotFoundErrorMessage = false;
                this.errorMessage = false;
                this.isNotAuthorizedCountry = false;
                this.notAuthorizedCountryMessage = '';
                var searchRequest = this.prepareMemberSearchForFboIdChange(this.distributorIDofValenceSearch);
                this._commonService.getFBOSearchResults(searchRequest)
                    .pipe(switchMap(function (memberSearchResponse) { return memberSearchResponse && memberSearchResponse.success && memberSearchResponse.fboSearchResultModelList && !memberSearchResponse.validations ? _this._commonService.getMemberAllowedCountries(memberSearchResponse.fboSearchResultModelList[0].id)
                    .pipe(map(function (memberAllowedCountries) { return ({ memberSearchResponse: memberSearchResponse, memberAllowedCountries: memberAllowedCountries }); })) : of({ memberSearchResponse: memberSearchResponse, memberAllowedCountries: [] }); }))
                    .subscribe(function (response) {
                    if (response.memberSearchResponse && response.memberAllowedCountries && response.memberAllowedCountries.length > 0 && response.memberSearchResponse.success && response.memberSearchResponse.recordsCount > 0 && response.memberSearchResponse.fboSearchResultModelList && !response.memberSearchResponse.validations) {
                        var isAuthorizedCountry = response.memberAllowedCountries.filter(function (country) { return country.isoCodeThree === _this.orderInformation.countryCode; });
                        if (isAuthorizedCountry && isAuthorizedCountry.length > 0) {
                            _this.distributorDetailsForValenceSearch = response.memberSearchResponse.fboSearchResultModelList[0];
                            _this.isMemberSearchSucess = true;
                        }
                        else {
                            _this.isNotAuthorizedCountry = true;
                            var errMsg = _this._translatePipe.get('validation-message.Entered DistributorID is not authorized to place order in {{store}}. Please try again.', { store: _this.orderInformation && _this.orderInformation.countryCode ? _this.orderInformation.countryCode : null });
                            _this.notAuthorizedCountryMessage = errMsg.value;
                        }
                    }
                    else if (response.memberSearchResponse && response.memberSearchResponse.validations && response.memberSearchResponse.validations.length > 0 && response.memberAllowedCountries.length === 0) {
                        if ((response.memberSearchResponse.validations[0].name.toLocaleLowerCase() === "completed") && (response.memberSearchResponse.validations[0].message.toLocaleLowerCase() === Constants.NOT_FPC_OR_FBO_CUSTOMER.toLocaleLowerCase() || response.memberSearchResponse.validations[0].message.toLocaleLowerCase() === Constants.NOT_ACTIVE.toLocaleLowerCase())) {
                            _this.FPCOrFBONotFoundErrorMessage = true;
                        }
                        else if (response.memberSearchResponse.validations[0].name.toLocaleLowerCase() === "not exist" && response.memberSearchResponse.validations[0].message.toLocaleLowerCase() === Constants.NOT_EXIST_MSG.toLocaleLowerCase()) {
                            _this.errorMessage = true;
                        }
                    }
                }, function (error) {
                    _this.closeupdateFboIdOfAnOrderModalPopup(true);
                    _this.toasterMsg('common.Sorry error occurred while fetching member details.', NotificationType.ERROR);
                });
            }
        }
    };
    RecentOrderViewComponent.prototype.prepareMemberSearchForFboIdChange = function (distributorID) {
        if (distributorID) {
            var searchRequest = {
                pageNumber: 1,
                pageSize: 10,
                sort: 'DESC',
                isAdvancedSearch: false,
                searchBy: 'MEMBER',
                sortOrder: ['fboId'],
                searchCriteria: [
                    {
                        searchKey: 'FBOID',
                        searchValue: distributorID
                    }
                ],
                valenceSearch: true
            };
            return searchRequest;
        }
        return null;
    };
    RecentOrderViewComponent.prototype.confirmationModalForUpdatingFboIdOfAnOrder = function () {
        this.closeupdateFboIdOfAnOrderModalPopup();
        this.distributorIDofValenceSearch = '';
        this.isConfirmationModalMessage = true;
        this.confirmOrSuccessFboIdOfAnOrderModal.open();
    };
    RecentOrderViewComponent.prototype.onValueChanges = function () {
        var _this = this;
        this.formSubscription = this.FboIDSearchForm.get('distributorID').valueChanges
            .pipe(debounceTime(1000))
            .subscribe(function (res) {
            if (_this.distributorIDofValenceSearch != '') {
                if (res === _this.distributorIDofValenceSearch) {
                    _this.isMemberSearchSucess = true;
                }
                else {
                    _this.isMemberSearchSucess = false;
                    _this.FPCOrFBONotFoundErrorMessage = false;
                    _this.errorMessage = false;
                    _this.isNotAuthorizedCountry = false;
                }
            }
        });
    };
    RecentOrderViewComponent.prototype.getBonusRunStatusDetails = function (type) {
        var _this = this;
        this.bonusDetails = null;
        var todayDate = new Date(this.orderInformation.orderPostedDate).getDate();
        var currentMonth = this.orderInformation.processedMonth;
        var currentYear = this.orderInformation.processedYear;
        if ((currentMonth != null && currentMonth != 0) && (currentYear != null && currentYear != 0)) {
            this._customerservice.getBonusRunStatusDetails(this.storeInfo.operatingCountry, currentMonth, currentYear).subscribe(function (res) {
                if (res && res.success && res.validations.length === 0) {
                    _this.bonusDetails = res;
                    if (type) {
                        if (type.toLowerCase() === Constants.CANCEL_ORDER.toLowerCase()) {
                            _this.openCancelOrderPopup();
                        }
                        if (type.toLowerCase() === Constants.UPDATE_FBOID_OF_ORDER.toLowerCase()) {
                            _this.checkBonusStatusAndOrderStatus(res);
                        }
                        if (type == Constants.PROCESSING_PERIOD) {
                            _this.populateBonusStatuses();
                        }
                    }
                }
                else if (res && res.validations && res.validations.length > 0) {
                    _this.toasterMsg('common.Sorry error occurred while fetching bonus run status for selected period.', NotificationType.ERROR);
                }
            }, function (err) {
                _this.distributorIDofValenceSearch = '';
                _this.toasterMsg('common.Sorry error occurred while fetching bonus run status for selected period.', NotificationType.ERROR);
            });
        }
        else {
            // this.orderInformation.webOrderId
            var message = null;
            if (type.toLowerCase() === Constants.CANCEL_ORDER.toLowerCase()) {
                message = 'validation-message.Sorry, the order {{webOrderId}} that you are trying to cancel is not qualified for cancelation due to following reasons';
            }
            if (type.toLowerCase() === Constants.UPDATE_FBOID_OF_ORDER.toLowerCase()) {
                message = 'validation-message.Sorry, the distributorId update on order {{webOrderId}} that you are trying to change is not possible currently, due to following reasons';
            }
            message = message + ' <ul><li>Payment not completed</li></ul>';
            this.toasterMsg(message, NotificationType.ERROR, true);
        }
    };
    RecentOrderViewComponent.prototype.confirmUpdateFboIdForExistingOrder = function () {
        var _this = this;
        this.isConfirmationModalMessage = false;
        this.closeconfirmationOrSucessModalForUpdatingFboIdOfAnOrder(false, false);
        this._orderservice.updateDistributorIdForExistingOrder(this.orderInformation.id, this.orderInformation.webOrderId, this.distributorDetailsForValenceSearch.fboId, this.userInfo.userId, this.storeInfo.operatingCountry)
            .subscribe(function (res) {
            if (res && res.validations && res.success) {
                _this.isDistributorIdChangedSuccessMessage = true;
                _this.confirmOrSuccessFboIdOfAnOrderModal.open();
            }
            else if (res && res.validations && res.validations.length > 0) {
                _this.toasterMsg('common.Sorry error occurred while updating FBOID of the order.', NotificationType.ERROR);
            }
        }, function (err) {
            _this.toasterMsg('common.Sorry error occurred while updating FBOID of the order.', NotificationType.ERROR);
        });
        this.isMemberSearchSucess = false;
        this.FPCOrFBONotFoundErrorMessage = false;
        this.errorMessage = false;
        this.isNotAuthorizedCountry = false;
    };
    RecentOrderViewComponent.prototype.closeconfirmationOrSucessModalForUpdatingFboIdOfAnOrder = function (isConfirmationPopUp, isSuccessPopUp) {
        if (isSuccessPopUp) {
            this.isDistributorIdChangedSuccessMessage = false;
            this.distributorDetailsForValenceSearch = null;
            this.closeTabForParticularDistributor.emit(this.orderInfo.distributorID);
        }
        if (isConfirmationPopUp) {
            this.isConfirmationModalMessage = false;
            this.isMemberSearchSucess = this.isConfirmationModalMessage;
            this.distributorDetailsForValenceSearch = null;
        }
        this.distributorIDofValenceSearch = '';
        this.confirmOrSuccessFboIdOfAnOrderModal.close();
    };
    RecentOrderViewComponent.prototype.editProcessingPeriod = function () {
        this.bonusStatuses = [];
        this.selectedBonusPeriod = null;
        this.submitProcessOrder = false;
        if (!this.hasCommissionActvityPermission
            && !(this.orderInformation && this.orderInformation.processedMonth && this.orderInformation.processedYear))
            return;
        var currentDate = new Date();
        var processingPeriod = new Date(this.orderInformation.processedYear, this.orderInformation.processedMonth - 1, 1);
        var nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
        if (processingPeriod >= nextMonth) {
            this.toasterMsg('common.Sorry Bonus Status is not available for the order processing period', NotificationType.ERROR);
            return;
        }
        this.getBonusRunStatusDetails(Constants.PROCESSING_PERIOD);
    };
    RecentOrderViewComponent.prototype.populateBonusStatuses = function () {
        var _this = this;
        if (this.bonusDetails && this.bonusDetails.success && (this.bonusDetails.bonusStatusId == BonusStatus.OPEN || this.bonusDetails.bonusStatusId == BonusStatus.RESTRICTED)) {
            var reqObj_1 = this.prepareRequestObjForBonusStatus();
            if (reqObj_1 && !!reqObj_1.length) {
                var modifyReqObj = reqObj_1.filter(function (x) { return _this.orderInformation.processedMonth != x.month; });
                this.processingPeriodModal.open();
                var reqs = [];
                for (var i = 0; i < modifyReqObj.length; i++) {
                    reqs.push(this._customerservice.getBonusRunStatusDetails(modifyReqObj[i].opCo, modifyReqObj[i].month, modifyReqObj[i].year).pipe(catchError(function (err) {
                        return of({ isError: true, error: err });
                    })));
                }
                forkJoin(reqs).pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (res) {
                    _this.bonusStatuses = [];
                    if (res && !!res.length) {
                        res.splice(1, 0, __assign({}, _this.bonusDetails));
                        res.forEach(function (bonusResponses, i) {
                            var statuses = _this.setBonusStatus(bonusResponses);
                            _this.bonusStatuses.push({
                                status: statuses,
                                month: Months[reqObj_1[i].month],
                                processedMonth: reqObj_1[i].month,
                                year: reqObj_1[i].year,
                                disabled: statuses && _this.checkStatus(statuses) ? false : true
                            });
                        });
                        var futureProcessingPeriod = !!_this.bonusStatuses.length && _this.bonusStatuses[_this.bonusStatuses.length - 1];
                        if (futureProcessingPeriod && futureProcessingPeriod.status && futureProcessingPeriod.status.toLowerCase() == Constants.BONUS_STATUS_NOT_AVAILABLE) {
                            futureProcessingPeriod.disabled = false;
                        }
                        var currentBonusPeriod = !!_this.bonusStatuses.length && _this.bonusStatuses.find(function (bonusPeriod) { return bonusPeriod.processedMonth == _this.orderInformation.processedMonth; });
                        _this.selectedBonusPeriod = currentBonusPeriod && !!Object.keys(currentBonusPeriod).length ? currentBonusPeriod : {};
                    }
                    else {
                        _this.selectedBonusPeriod = {};
                        _this.toasterMsg('common.Sorry error occurred while fetching bonus run status', NotificationType.ERROR);
                    }
                }, function (err) {
                    _this.selectedBonusPeriod = {};
                    _this.toasterMsg('common.Sorry error occurred while fetching bonus run status', NotificationType.ERROR);
                });
            }
        }
        else {
            this.toasterMsg('common.Bonus Statuses is not Open or Restricted', NotificationType.ERROR);
        }
    };
    RecentOrderViewComponent.prototype.prepareRequestObjForBonusStatus = function () {
        var reqObj = [];
        var processingMonth = this.orderInformation.processedMonth;
        var processingYear = this.orderInformation.processedYear;
        var processingPeriod = new Date(processingYear, processingMonth - 1, 1);
        var pastProcessingPeriod = new Date(processingPeriod.getFullYear(), processingPeriod.getMonth() - 1);
        var futureProcessingPeriod = new Date(processingPeriod.getFullYear(), processingPeriod.getMonth() + 1);
        reqObj = [
            { opCo: this.storeInfo.operatingCountry, month: pastProcessingPeriod.getMonth() + 1, year: pastProcessingPeriod.getFullYear(), },
            { opCo: this.storeInfo.operatingCountry, month: processingPeriod.getMonth() + 1, year: processingPeriod.getFullYear() },
            { opCo: this.storeInfo.operatingCountry, month: futureProcessingPeriod.getMonth() + 1, year: futureProcessingPeriod.getFullYear() }
        ];
        return reqObj;
    };
    RecentOrderViewComponent.prototype.setBonusStatus = function (bonusResponses) {
        var Status = Constants.ERROR_OCCURED_FETCHING_BONUS_STATUS;
        if (bonusResponses && !!Object.keys(bonusResponses).length) {
            if (bonusResponses.success)
                return bonusResponses.bonusStatus;
            if (!bonusResponses.success && bonusResponses.validations && !!bonusResponses.validations.length) {
                for (var i = 0; i < bonusResponses.validations.length; i++) {
                    if (bonusResponses.validations[i].message && bonusResponses.validations[i].message.toLowerCase()
                        && (bonusResponses.validations[i].message.toLowerCase().indexOf(Constants.NOT_AVAILABLE) > -1)) {
                        Status = Constants.BONUS_STATUS_NOT_AVAILABLE;
                        break;
                    }
                }
            }
        }
        return Status;
    };
    RecentOrderViewComponent.prototype.toasterMsg = function (msg, type, isProcessingPeriodNotAvailable) {
        var errorMessage;
        if (isProcessingPeriodNotAvailable != null && isProcessingPeriodNotAvailable) {
            errorMessage = this._translatePipe.get(msg, { webOrderId: this.orderInformation && this.orderInformation.webOrderId ? this.orderInformation.webOrderId : null });
        }
        else {
            errorMessage = this._translatePipe.get(msg);
        }
        this._commonService.createNotification('', errorMessage.value, type);
    };
    RecentOrderViewComponent.prototype.isProcessingPeriodHasAccess = function () {
        if (this.bonusStatuses && !!this.bonusStatuses.length && this.selectedBonusPeriod && this.orderInformation && this.orderInformation.processedMonth) {
            this.selectedBonusPeriod.error = false;
            this.selectedBonusPeriod.errMsg = " ";
            if (this.orderInformation.processedMonth == this.selectedBonusPeriod.processedMonth)
                return false;
            if (this.selectedBonusPeriod.disabled) {
                this.selectedBonusPeriod.error = true;
                this.selectedBonusPeriod.errMsg = this.selectedBonusPeriod.month + ' ' + Constants.NOT_OPEN_OR_RESTRICTED_STATUSES;
                return false;
            }
            return true;
        }
        return false;
    };
    RecentOrderViewComponent.prototype.isBonusStatusOpenOrRestricted = function (period) {
        var getStatus = this.bonusStatuses.find(function (status) { return (status.processedMonth == period); });
        return getStatus && getStatus.status && this.checkStatus(getStatus.status);
    };
    RecentOrderViewComponent.prototype.checkStatus = function (status) {
        if (status && (status.toLowerCase() == BonusConstants.Open.toLowerCase() ||
            status.toLowerCase() == BonusConstants.Restricted.toLowerCase())) {
            return true;
        }
        return false;
    };
    RecentOrderViewComponent.prototype.submitProcessingPeriod = function () {
        if (this.isProcessingPeriodHasAccess()) {
            this.submitProcessOrder = true;
        }
    };
    RecentOrderViewComponent.prototype.confirmProcessingPeriod = function () {
        var _this = this;
        if (this.submitProcessOrder && this.orderInfo && this.orderInfo.webOrderID && this.orderInfo.homeCountry && this.orderInformation) {
            this.processingPeriodModal.close();
            this._orderservice.updateProcessingPeriodForOrder(this.orderInfo.webOrderID, this.orderInfo.homeCountry, this.selectedBonusPeriod.year, this.selectedBonusPeriod.processedMonth, this.userInfo.userId, this.orderInformation.id).subscribe(function (res) {
                if (res && res.success) {
                    _this.getRecentOrderInformation();
                    _this.toasterMsg('common.Order Processing Period updated successfully', NotificationType.SUCCESS);
                }
                else {
                    _this.toasterMsg('common.Sorry error occurred while updating processing period of the order', NotificationType.ERROR);
                }
            }, function (err) {
                _this.toasterMsg('common.Sorry error occurred while updating processing period of the order', NotificationType.ERROR);
            });
        }
    };
    RecentOrderViewComponent.prototype.closeProcessingPeriod = function () {
        if (this.submitProcessOrder) {
            this.submitProcessOrder = !this.submitProcessOrder;
            return;
        }
        this.processingPeriodModal.close();
    };
    RecentOrderViewComponent.prototype.checkBonusStatusAndOrderStatus = function (res) {
        if ((res.bonusStatus.toLocaleLowerCase() === Constants.BONUS_RUN_STATUS_OPEN.toLocaleLowerCase() || res.bonusStatus.toLocaleLowerCase() === Constants.BONUS_RUN_STATUS_RESTRICTED.toLocaleLowerCase())) {
            if (!(this.orderInformation.orderStatusId === OrderStatusEnums.Cancelled || this.orderInformation.orderStatusId === OrderStatusEnums.Failed))
                this.changeDistributorIdForAnExistingOrder();
            else
                this.toasterMsg('common.Sorry You are unable to update FBOID of the order because its status is failed or cancelled.', NotificationType.ERROR);
        }
        else
            this.toasterMsg("common.The bonus run status for this order's processing period is not open or restricted.", NotificationType.ERROR);
    };
    /*    getMembergovernmentIdentificationsInfo(memberId: number) {
            if(memberId){
                this._customerservice.getMembergovernment_identifications(memberId).subscribe(response =>{
                    if(response && response.memberGovernmentIdentificationModel){
                      this.memberGovernmentIdentifiations = response.memberGovernmentIdentificationModel;
                    }
                    this.getShippingCostWithShippingTax();
                });
            }
        }
    
        getVatIdfromMember() {
            const countries = this._cacheService.get(CacheKey.COUNTRIES);
            const orderCountryId = countries.find((y: Country) => y.isocodeThree.toUpperCase() === this.orderInformation.countryCode.toUpperCase()).countryId;
            if(this.memberGovernmentIdentifiations){
                const memberGovernmentIdentifiation = this.memberGovernmentIdentifiations.find(x => (x.governmentIdentificationType).toUpperCase() === GovernmentIdentificationType.VAT_ID && x.countryID === orderCountryId);
                this.memberInfo.vatRegistered = memberGovernmentIdentifiation ? true : false;
            }
        } */
    RecentOrderViewComponent.prototype.ngOnDestroy = function () {
        this.formSubscription && this.formSubscription.unsubscribe();
        if (this.ngUnsubscribe) {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
        }
    };
    return RecentOrderViewComponent;
}());
export { RecentOrderViewComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/recent-order-view.component.ts.pre-build-optimizer.js